import React from 'react';
import PropTypes from 'prop-types';
import { BsXLg } from 'react-icons/bs';
import { Modal } from 'bootstrap';
import EpButton from '../EpButton';
import './styles.scss';

let lastAction = 'close';
let modalInstance = null;

export const handleToggleModal = (modalId, modalOptions) => {
  const modalEl = document.getElementById(modalId);
  modalInstance = Modal.getOrCreateInstance(modalEl, modalOptions);

  if (lastAction === 'close') {
    lastAction = 'open';
    modalInstance.show();
  } else if (lastAction === 'open') {
    lastAction = 'close';
    modalInstance.hide();
  }
};

const EpModal = ({
  noHeader, headerTitle, headerContent, bodyContent, footerContent, alignFooter, size,
  modalId,
}) => (
  <div className="modal fade" id={modalId}>
    <div className={`modal-dialog modal__dialog ${size}`}>
      <div className="modal-content modal__content">
        {!noHeader
          && (
            <div className="modal-header modal__header">
              <h2 className="modal-title modal__header-title">{headerTitle}</h2>
              {headerContent || ''}

              <EpButton
                buttonStartIcon={<BsXLg className="btn__icon" />}
                buttonType="link-secondary"
                customClass="modal__header-button--close"
                onClickFunc={() => handleToggleModal(modalId)}
                actionType="button"
                buttonSize="sm"
              />
            </div>
          )}

        <div className="modal-body modal__body">
          {bodyContent}
        </div>

        {footerContent
          && (
            <div className={`modal-footer modal__footer d-flex ${alignFooter}`}>
              {footerContent}
            </div>
          )}
      </div>
    </div>
  </div>
);
export default EpModal;

EpModal.defaultProps = {
  headerTitle: '',
  headerContent: null,
  noHeader: null,
  alignFooter: 'justify-content-between',
  size: 'md',
};

EpModal.propTypes = {
  noHeader: PropTypes.bool,
  headerTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  headerContent: PropTypes.element,
  bodyContent: PropTypes.element.isRequired,
  footerContent: PropTypes.element.isRequired,
  alignFooter: PropTypes.oneOf(['justify-content-start', 'justify-content-center', 'justify-content-between', 'justify-content-end', 'justify-content-around']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  modalId: PropTypes.string.isRequired,
};
